import { NodeProps, RENDER } from '../metadata';

import { resolveProps } from '.';

interface ShouldRenderElementOptions {
  breakpoint?: string;
  locale?: string;
}

function shouldRenderElement(props: NodeProps, options: ShouldRenderElementOptions = {}): boolean {
  const { breakpoint, locale } = options;

  const resolvedProps = resolveProps(props, breakpoint, locale);
  const renderProp = resolvedProps[RENDER] as boolean;

  return renderProp !== false;
}

export default shouldRenderElement;
